/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMaterialDto } from '../../models/backend-material-dto';

export interface OpexesMaterialsList$Params {
  /**
   * id Варианта
   */
  variant?: number;
}

export function opexesMaterialsList(
  http: HttpClient,
  rootUrl: string,
  params?: OpexesMaterialsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMaterialDto>>> {
  const rb = new RequestBuilder(rootUrl, opexesMaterialsList.PATH, 'get');
  if (params) {
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMaterialDto>>;
    }),
  );
}

opexesMaterialsList.PATH = '/api/opexes/materials/';
